var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"videoContent"}},[(_vm.videoPath)?_c('h5-video',{staticClass:"vjs-custom-skin",attrs:{"video-path":_vm.videoPath,"start-time":_vm.timeStamp.startTime,"end-time":_vm.timeStamp.endTime},on:{"ready":_vm.playerReadied,"nodePlayEnd":_vm.nodePlayEnd}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }